<template>
  <div>
    <h3 ref="ia">
      Pythagorean Theorem
    </h3>
    <p>
      The Pythagorean Theorem, named after Greek philosopher Pythagoras, states that &mdash; in a right-angled triangle, the square of the longest side (also known as hypotenuse) is equal to the sum of the squares of
      the other two sides. For example, consider the right-angled triangle OAB shown in the figure below. AB is the hypotenuse, OA is the base, and OB is the height of this triangle.
      According to the Pythagorean theorem, these three sides are related as follows:
      $$(OA)^2 + (OB)^2 = (AB)^2$$
      This equation is also known as the Pythagorean formula.
      Note that the Pythagorean formula is a fundamental property of any right-angled triangle, i.e. it holds true for all right-angled triangles.
    </p>
    <br>
    <v-layout justify-center>
      <v-img
        src="/assets/pyt.png"
        max-height="450px"
        max-width="450px"
        contain
      />
    </v-layout>
    <h3 ref="magicgraph">
      MagicGraph | Pythagorean Theorem
    </h3>
    <p>
      This MagicGraph offers a visually interactive illustration of Pythagorean theorem. You are given a right-angled triangle OAB. OA is the base, OB is the height and AB is the hypotenuse.
      Points A and B of the triangle can be dragged to change the base and height of the triangle. Point O is fixed and cannot be dragged.
    </p>
    <h5>To Get Started:</h5>
    <p>
      Imagine three squares that are conjoined with the three sides of the triangle &mdash; as shown in the figure below.
      The area of a given square is equal to square of the side that it is conjoined with.
      For example, the area of the green square equals \((OB)^2\), the area of the blue square equals \((OA)^2\), and the area of the red square equals \((AB)^2\).
      The area of each square can be measured in number of bins inside that square.
      Then, Pythagorean theorem implies &mdash;
      <br>
      $$ \text{No. of bins inside green square} + \text{No. of bins inside blue square} = \text{No. of bins inside red square}. $$
      <br>
    </p>
    <h5>To Explore:</h5>
    <p>
      Drag points A and B to change the base and height dimensions of the triangle. Then, count the number of bins in each of the three squares.
      Using MagicGraph, verify that the total number of bins in the blue and green squares equals the number of bins in the red square.
    </p>
    <v-responsive>
      <v-layout justify-center>
        <div id="jxgbox1" class="edliy-box-about" />
      </v-layout>
    </v-responsive>
  </div>
</template>
<script>
import Boxes from './Boxes.js'
export default {
  name: 'PythagoreanTheorem',
  created: function () {
    this.$store.commit('navigation/resetState');
    let title = 'Pythagoras Theorem';
    this.$store.commit('navigation/changeTitle', title);
    this.$store.commit('navigation/changeMenu', title);
    let newTopics = [
      {title: 'Pythagorean Theorem', img:'/assets/number-1.svg', action: () => this.goto('ia')},
      {title: 'MagicGraph',img:'/assets/touch.svg', action: () => this.goto('magicgraph')},
    ];
    this.$store.commit('navigation/replaceTopics', newTopics);
    let newshowhome = false;
    this.$store.commit('navigation/toggleshowhome', newshowhome);
    let newMath =true;
    this.$store.commit('navigation/replaceMath', newMath);
    let newLeftArrow =true;
    this.$store.commit('navigation/replaceLeftArrow', newLeftArrow);
    let newModule=true;
    this.$store.commit('navigation/replaceModule', newModule);
  },
  mounted () {
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    Boxes.box1();
  },
  metaInfo() {
  return{ title: 'Pythagorean Theorem',
          titleTemplate: '%s - Learn interactively',
          meta: [ {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                  {name: 'description', content: 'Learn interactively about Pythagorean Theorem'}
                ]
        }
   },
}
</script>
<style lang="scss">
@import 'src/styles/edliy-box.scss';
@import 'src/styles/edliy-box.scss';
@import 'src/styles/subtopic-menu.scss';
@import 'src/styles/edliy-box-about.scss';
</style>
